var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 133 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 64.543,
    r: 47.5,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.802 32.806h-23.967c-2.5966 0-4.7016 2.0557-4.7016 4.5916v54.176c0 2.5358 2.105 4.5916 4.7016 4.5916h23.967c2.5967 0 4.7016-2.0558 4.7016-4.5916v-54.176c0-2.5359-2.1049-4.5916-4.7016-4.5916z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.802 32.806h-3.0952s-1.6687 46.186-10.113 63.359h13.208c2.5966 0 4.7016-2.0558 4.7016-4.5916v-54.176c0-2.5359-2.105-4.5916-4.7016-4.5916z",
    fill: "#CCEFDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.259 32.806h14.461v1.2622c-0.0012 0.227-0.0486 0.4514-0.1395 0.6603s-0.2235 0.398-0.39 0.5564c-0.1665 0.1583-0.3636 0.2827-0.5798 0.3659s-0.4472 0.1236-0.6796 0.1187h-10.92c-0.4645 0-0.91-0.1802-1.2385-0.501-0.3284-0.3207-0.5129-0.7558-0.5129-1.2094v-1.2531z",
    fill: "#00C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.93 36.484h-10.92c-0.6557 0-1.2846-0.2544-1.7483-0.7073-0.4637-0.4528-0.7242-1.067-0.7242-1.7075v-1.9756h15.922v1.9756c0 0.3218-0.0657 0.6404-0.1935 0.937-0.1277 0.2966-0.3149 0.5652-0.5505 0.7902s-0.5148 0.4017-0.8213 0.5197c-0.3065 0.1181-0.6341 0.1752-0.9635 0.1679zm-11.941-2.9727v0.5579c0 0.2645 0.1075 0.518 0.299 0.705 0.1914 0.187 0.4511 0.292 0.7218 0.292h10.92c0.2708 0 0.5304-0.105 0.7219-0.292 0.1914-0.187 0.299-0.4405 0.299-0.705v-0.5579h-12.962z",
    fill: "#00C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.804 97.08h-23.967c-1.4904 0-2.9197-0.5782-3.9735-1.6074-1.0539-1.0292-1.6459-2.4251-1.6459-3.8806v-54.194c0-1.4556 0.592-2.8514 1.6459-3.8806 1.0538-1.0292 2.4831-1.6074 3.9735-1.6074h23.967c1.4904 0 2.9197 0.5782 3.9735 1.6074 1.0539 1.0292 1.6459 2.425 1.6459 3.8806v54.176c0.0025 0.7223-0.1411 1.4379-0.4224 2.1058-0.2813 0.668-0.6948 1.2751-1.2168 1.7867-0.5221 0.5115-1.1424 0.9174-1.8254 1.1944-0.683 0.2769-1.4153 0.4194-2.1548 0.4194zm-23.967-63.359c-0.9936 0-1.9465 0.3855-2.649 1.0716-0.7026 0.6861-1.0973 1.6167-1.0973 2.5871v54.194c0 0.9704 0.3947 1.901 1.0973 2.5871 0.7025 0.6861 1.6554 1.0716 2.649 1.0716h23.967c0.9936 0 1.9464-0.3855 2.649-1.0716s1.0973-1.6167 1.0973-2.5871v-54.176c0-0.9704-0.3947-1.901-1.0973-2.5871s-1.6554-1.0716-2.649-1.0716l-23.967-0.0183z",
    fill: "#00C65E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.463,
    y: 82.059,
    width: 26.711,
    height: 9.427,
    rx: 1,
    fill: "#FFB762"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.463,
    y: 69.68,
    width: 26.711,
    height: 7.4341,
    rx: 1,
    fill: "#FFB762"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.465,
    y: 42.418,
    width: 26.711,
    height: 1.465,
    rx: 0.7325,
    fill: "#FFB762"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.465,
    y: 49.233,
    width: 26.711,
    height: 1.465,
    rx: 0.7325,
    fill: "#FFB762"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.465,
    y: 56.049,
    width: 16.65,
    height: 1.465,
    rx: 0.7325,
    fill: "#FFB762"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.465,
    y: 62.864,
    width: 13.374,
    height: 1.465,
    rx: 0.7325,
    fill: "#FFB762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.639 45.36 6.634-1.6097-6.7223-1.6269-1.6129-6.3524-1.6128 6.3524-6.7224 1.6269 6.6399 1.6097 1.6953 6.6916 1.7012-6.6916z",
    fill: "#00C65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.216 82.302 8.0302-1.9484-8.1371-1.9693-1.9524-7.6893-1.9523 7.6893-8.1371 1.9693 8.0302 1.9484 2.0592 8.1 2.0593-8.1z",
    fill: "#FFF06E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.042969,
    width: 133,
    height: 133,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "effect1_dropShadow_5137_18145"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_18145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_18145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(28 26.995)",
    width: 75,
    height: 75,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a7e3ee8128ee8862b51ccdbfb14ccc1c.svg";
export { ForwardRef as ReactComponent };